import {Badge} from "@mantine/core"
import {
    Account,
    AccountStatus
} from "../types.ts";

export const AccountStatusBadge = ({record}: { record: Account }) => {

    if (record.accountStatus === AccountStatus.ACTIVE) {
        return <Badge color={'green'}>Active</Badge>;
    } else if (record.accountStatus === AccountStatus.SUSPENDED) {
        return <Badge color={'red'}>Suspended</Badge>
    } else if (record.accountStatus === AccountStatus.PENDING_DELETION) {
        // FNP-383: amber/orange signals the 30-day soft-delete window — restorable
        // until scheduledHardDeleteAt, then it hard-deletes.
        return <Badge color={'orange'}>Pending Deletion</Badge>
    }
}